import React, { useContext } from "react";
import { Button, Image, Nav, Navbar, NavLink } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../Context/AuthProvider/AuthProvider";
import { FaUser } from "react-icons/fa";
import { ThemeContext } from "../../../Context/Theme";
import { DarkModeToggle } from "@anatoliygatt/dark-mode-toggle";
import "./Header.css"; // Import the CSS file for styling

import Container from "react-bootstrap/Container";

import Offcanvas from "react-bootstrap/Offcanvas";

const Header = () => {
  const { user, logOut } = useContext(AuthContext);
  const [{ theme, isDark }, toggleTheme] = useContext(ThemeContext);

  const handleLogOut = () => {
    logOut()
      .then(() => {})
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div className="shadow">
      <Navbar collapseOnSelect expand="sm">
        <Container className="py-2 d-flex align-items-center justify-content-center">
          <Navbar.Brand href="/" className="fs-2 text-center fw-bold">
            TechEdify
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="offcanvasNavbar" />
          <Navbar.Offcanvas
            id="offcanvasNavbar"
            placement="end"
            aria-labelledby="offcanvasNavbarLabel"
          >
            <Offcanvas.Body>
              <Nav className="mx-auto justify-content-center align-items-center">
                <Nav.Link
                  className="fs-5 text-dark fw-semibold"
                  href="/courses"
                >
                  Courses
                </Nav.Link>
                <Nav.Link className="fs-5 text-dark fw-semibold" href="#faq">
                  FAQ
                </Nav.Link>
                <Nav.Link className="fs-5 text-dark fw-semibold" href="#team">
                  Team
                </Nav.Link>
                <Nav.Link
                  className="fs-5 text-dark fw-semibold"
                  href="#feedback"
                >
                  Feedback
                </Nav.Link>
              </Nav>
              <Nav>
                <Nav.Link href="#deets">
                  {user?.uid ? (
                    <>
                      <NavLink
                        to="#"
                        className="nav-link text-dark fw-semibold fs-5"
                        onClick={handleLogOut}
                      >
                        LogOut
                      </NavLink>
                    </>
                  ) : (
                    <Nav.Link
                      className="text-dark fw-semibold fs-5"
                      href="/login"
                    >
                      Login
                    </Nav.Link>
                  )}
                </Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
